import React, { useEffect, useState } from 'react'
import { Modal, Button, message } from 'antd'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import mensagem from '../message/Message'
import {
  fazerReplicaAoFeedback,
  getFeedbackById,
} from '../../pages/fila/Functions-Fila'

function FeedbackWrapper ({ visible, onClose, user = {}, loading = false }) {
  const [record, setRecord] = useState({feedbackText: 'Carregando...'})
  const [responseText, setResponseText] = useState('')
  const [showModal, setShowModal] = useState(visible)

  useEffect(() => {
    if (visible && user?.id) {
      ;(async () => {
        try {
          const data = await getFeedbackById(user.id)
          const record = {
            id: data.id,
            vendedor: { id: data.vendedor.id },
            periodo:
              String(data.metaInfo.mes).padStart(2, '0') +
              '/' +
              data.metaInfo.ano,
            metaVendedor: data.vendedor.metaInfoPeriodo.meta,
            metaPorcentagemVendedor:
              data.vendedor.metaInfoPeriodo.metaPorcentagem,
            ticketMedio: data.vendedor.metaInfoPeriodo.ticketMedio,
            produtosPorAtendimento:
              data.vendedor.metaInfoPeriodo.produtosPorAtendimento,
            premioAcumulado: data.vendedor.metaInfoPeriodo.premioAcumulado,
            feedbackText:
              data.feedback.mensagem || 'Nenhum feedback fornecido.',
          }
          setRecord(record)
        } catch (err) {
          console.error(err)
        }
      })()
    }
  }, [visible, user?.id])

  const onSubmit = async response => {
    const isOk = await mensagem.confirmar(
      'Deseja enviar a resposta? Após confirmar, não será possível editá-la.',
    )
    if (isOk) {
      fazerReplicaAoFeedback(record.id, response)
      message.info('Feedback enviado com sucesso...')
      if (typeof onClose === 'function') {
        onClose(record.id, record.vendedor.id)
      }
    } else {
      const sair = await mensagem.confirmar('Deseja sair do feedback?')
      if (sair && typeof onClose === 'function') {
        onClose(record.id, record.vendedor.id)
      }
    }
  }

  const handleCancel = async () => {
    const isOk = await mensagem.confirmar('Deseja sair do feedback?')
    if (isOk) {
      setShowModal(false)
      if (typeof onClose === 'function') {
        onClose(record.id, record.vendedor.id)
      }
    }
  }

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  }

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'image',
  ]

  return (
    <Modal
      title='Feedback'
      open={showModal}
      destroyOnClose
      centered
      footer={null}
      closable
      onCancel={handleCancel}
      confirmLoading={loading}
    >
      <div
        className='feedback-info'
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '1rem',
        }}
      >
        <div>
          <strong>Período:</strong> {record.periodo}
        </div>
        <div>
          <strong>Meta:</strong> {record.metaVendedor}
        </div>
        <div>
          <strong>Percentual atingido:</strong> {record.metaPorcentagemVendedor}
        </div>
        <div>
          <strong>Ticket Médio:</strong> {record.ticketMedio}
        </div>
        <div>
          <strong>Peças por Atendimento:</strong>{' '}
          {record.produtosPorAtendimento}
        </div>
        <div>
          <strong>Prêmio:</strong> {record.premioAcumulado}
        </div>
      </div>

      <div style={{ marginTop: '1.5rem' }}>
        <label
          style={{
            fontWeight: 600,
            fontSize: '1.2rem',
            display: 'block',
            marginBottom: '0.5rem',
          }}
        >
          Feedback:
        </label>
        <div
          className='ql-container ql-snow'
          style={{
            backgroundColor: '#fafafa',
            color: '#888',
            padding: '1rem',
            borderRadius: '4px',
            overflowY: 'auto',
          }}
          dangerouslySetInnerHTML={{
            __html:
              `<style>
      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        margin: 0.5rem 0;
      }
    </style>` + record.feedbackText,
          }}
        />
      </div>

      <div style={{ marginTop: '1.5rem' }}>
        <label
          style={{
            fontWeight: 600,
            fontSize: '1.2rem',
            display: 'block',
            marginBottom: '0.5rem',
          }}
        >
          Deseja responder?
        </label>
        <ReactQuill
          theme='snow'
          value={responseText}
          onChange={setResponseText}
          modules={{
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ header: [1, 2, 3, false] }],
              ['link'], // <- SEM 'image'
              ['clean'],
            ],
          }}
          formats={[
            'bold',
            'italic',
            'underline',
            'strike',
            'list',
            'bullet',
            'header',
            'link',
          ]}
          placeholder='Escreva sua resposta...'
          style={{
            backgroundColor: 'white',
            fontSize: '1.2rem',
          }}
        />
      </div>

      <div
        style={{
          marginTop: '1.5rem',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '1rem',
        }}
      >
        <Button onClick={handleCancel} type='danger'>
          Fechar
        </Button>
        <Button
          type='primary'
          loading={loading}
          onClick={() => onSubmit(responseText)}
          disabled={
            !responseText ||
            responseText.replace(/<[^>]+>/g, '').trim().length < 10
          }
        >
          Enviar
        </Button>
      </div>
    </Modal>
  )
}

export default FeedbackWrapper
